import styled from 'styled-components';

export const StyledCctvWrapper = styled.div`
  position: absolute;
  top: 70px;
  right: 10px;
  z-index: 20;

  display: flex;
  flex-direction: column;
  gap: 12px;

  background-color: #212121e5;
  margin: 4px;
  padding: 4px 16px 16px 16px;
  border: 0.5px solid #e0e0e080;
  box-shadow: 0 0 15.5px 0 #e0e0e080;

  border-radius: 10px;

  min-width: 400px;

  user-select: none;
  touch-action: none; /* pointer drag 시 스크롤/줌 방지 */

  cursor: grab;

  &.dragging {
    cursor: grabbing;
  }

  .drag-handle {
    display: flex;
    align-items: center;
    justify-content: space-between;

    height: 36px;
    margin: 0 -16px;
    padding: 0 12px;

    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
    cursor: grab;
  }

  &.dragging .drag-handle {
    cursor: grabbing;
  }

  .image-box {
    width: 62px;
    height: 62px;
    border-radius: 50%;
    background-color: #eeeeee;
  }

  .user-box {
    display: flex;
    flex-direction: column;
    gap: 2px;

    > h2 {
      color: var(--color-white);
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }

    > p {
      color: var(--color-white);
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
`;
